<template>
  <div
    v-if="serviceCostReport"
    class="content"
  >
    <v-row no-gutters>
      <v-col cols="12">
        <div class="headline mt-4">
          <strong>Service Report</strong>
        </div>

        <div class="title mt-2">
          Yacht: {{ serviceCostReport.yacht.name }}
        </div>

        <div class="body-2">
          Hull: {{ serviceCostReport.yacht.hull_number }}
        </div>

        <div class="subtitle-1 mt-2">
          Period: {{ serviceCostReport.date_from | moment('D MMM YYYY') }} - {{ serviceCostReport.date_to | moment('D MMM YYYY') }}<br>
        </div>
      </v-col>
      <v-col class="text-right pr-4">
        <img
          src="@/assets/logo.png"
          alt="Navigare Yachting"
          style="height: 100px"
        >
      </v-col>
    </v-row>

    <table class="mt-12">
      <thead>
        <tr>
          <th class="px-4 py-2">
            Service
          </th>
          <th class="px-4 py-2 text-right">
            Total Price
          </th>
        </tr>
      </thead>
      <tbody>
        <template
          v-for="task in serviceCostReport.items"
        >
          <tr :key="task.id">
            <td
              style="min-width: 400px"
              class="px-4 py-2"
            >
              <div>
                {{ task.title }}
              </div>
              <div class="caption grey--text">
                <span>#{{ task.id }} &middot; </span>
                <span v-if="task.description">{{ task.description }}</span>
              </div>
              <div v-if="task.deposit_insurance || task.hull_insurance || task.is_warranty_claim">
                <v-chip
                  v-if="task.deposit_insurance"
                  x-small
                  color="grey darken-1"
                  outlined
                  label
                >
                  Deposit Insurance Claim
                </v-chip>
                <v-chip
                  v-if="task.hull_insurance"
                  x-small
                  color="grey darken-1"
                  outlined
                  label
                >
                  Hull Insurance Claim
                </v-chip>
                <v-chip
                  v-if="task.is_warranty_claim"
                  small
                  color="grey darken-1"
                  outlined
                  label
                >
                  Warranty Claim
                  <span
                    v-if="task.warranty_claim_resolution === null"
                    class="ml-1"
                  >
                    Pending
                  </span>
                  <span
                    v-else-if="task.warranty_claim_resolution === true"
                    class="success--text ml-1"
                  >
                    Accepted
                  </span>
                  <span
                    v-else
                    class="error--text ml-1"
                  >
                    Rejected
                  </span>
                  <span
                    v-if="task.warranty_claim_resolution_at"
                    class="ml-1"
                  >
                    ({{ task.warranty_claim_resolution_at | moment('D MMM YYYY') }})
                  </span>
                </v-chip>
              </div>
              <div
                v-if="task.warranty_insurance_note"
                class="caption grey--text"
              >
                Warranty / Insurance: {{ task.warranty_insurance_note }}
              </div>
              <div
                class="caption mt-1 grey--text text--darken-2"
              >
                <v-row
                  no-gutters
                  class="py-1 alternating-rows"
                >
                  <!--                  <v-col cols="3">-->
                  <!--                    Code-->
                  <!--                  </v-col>-->
                  <v-col cols="7">
                    Part / Service
                  </v-col>
                  <v-col cols="3">
                    Qty
                  </v-col>
                  <v-col cols="3">
                    Unit Price
                  </v-col>
                  <v-col
                    cols="3"
                    class="text-right"
                  >
                    Price
                  </v-col>
                </v-row>
                <v-row
                  v-for="(item, index) in task.items.filter(i => i.included)"
                  :key="task.id + index"
                  class="alternating-rows"
                  no-gutters
                >
                  <v-col cols="7">
                    {{ item.name }}
                  </v-col>
                  <v-col cols="3">
                    {{ item.quantity }} {{ item.unit }}
                  </v-col>
                  <v-col
                    cols="3"
                  >
                    {{ item.unit_price | currency(item.currency, 2) }}
                  </v-col>
                  <v-col
                    cols="3"
                    class="text-right"
                  >
                    {{ item.price | currency(item.currency, 2) }}
                  </v-col>
                </v-row>
              </div>
            </td>
            <td
              class="text-right px-4 py-2"
              style="vertical-align: baseline"
            >
              {{ task.price | currency(serviceCostReport.currency, 2) }}
            </td>
          </tr>
        </template>

        <tr>
          <td
            class="px-4 py-2 no-border"
          >
            <v-row
              no-gutters
              align="center"
            >
              <v-col class="grey--text caption text--lighten-2">
                All prices without VAT
              </v-col>
              <v-col
                cols="auto"
                class="font-weight-bold subtitle-1"
              >
                SUBTOTAL
              </v-col>
            </v-row>
          </td>
          <td class="text-right font-weight-bold subtitle-1 px-4 py-2 no-border text-no-wrap">
            {{ serviceCostReport.price | currency(serviceCostReport.currency, 2) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ServiceCostReport from '@/models/ServiceCostReport'

export default {
    name: 'ServiceCostReportPrint',
    components: {
    },
    data() {
      return {
        serviceCostReport: null
      }
    },
    computed: {
    },
    watch: {
      serviceTasks: function (value) {
        this.prepareServiceTasks()
      }
    },
    created() {
      this.fetchCostReport()
    },
    methods: {
      async fetchCostReport() {
        this.serviceCostReport = await ServiceCostReport.api.find(this.$route.params.id)

        this.print()
      },
      print() {
        setTimeout(() => {
          window.print()
          window.close()
        }, 300)
      }
    }
  }
</script>

<style lang="css" scoped>
  table {
    border-radius: 2px;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    max-width: 100%;
  }

  table tbody td {
    border-bottom: 1px solid #aeaeae;
    margin: 0;
  }

  table tbody td.no-border {
    border-bottom: none;
    margin: 0;
  }

  table thead th {
    text-align: left;
    border-bottom: 1px solid #aeaeae;
    margin: 0;
  }

  .alternating-rows {
    border-bottom: 1px solid #eeeeee;
  }

  .alternating-rows:last-child {
    border-bottom: none;
  }
</style>
